<template>
  <div>
    <div class="appui">
      <div class="appui-head">
        <div>
          <h1 class="appui-title">Gamificação</h1>
          <div class="appui-crumb">App <span class="sep">/</span> Gamificação</div>
        </div>
      </div>

      <div class="appui-gam-grid">
        <!-- Regras de pontos -->
        <section class="appui-card appui-card--flush">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left">
              <span class="appui-sec-title">Pontos por ação</span>
              <label class="appui-toolbar-hint" style="display:inline-flex;align-items:center;gap:8px;margin-left:8px;cursor:pointer">
                Gamificação ativa
                <button class="appui-switch" :class="{ 'is-on': enabled }" @click="toggleGlobal()"><span class="knob"></span></button>
              </label>
            </div>
            <div class="appui-card-toolbar-right">
              <button class="appui-btn appui-btn--primary" @click="openCreate()">+ Nova ação</button>
            </div>
          </div>

          <div v-if="!rules.length" class="appui-inline-empty">Nenhuma ação de pontuação configurada.</div>
          <table v-else class="appui-table">
            <thead><tr><th>Ação</th><th style="width:130px">Pontos</th><th style="width:80px">Ativa</th><th style="width:60px;text-align:right"></th></tr></thead>
            <tbody>
              <tr v-for="r in rules" :key="r.id">
                <td>
                  <div style="font-weight:500;color:#495057">{{ r.description }}</div>
                  <div style="font-size:11px;color:#adb5bd;font-family:ui-monospace,monospace">{{ r.action }}</div>
                </td>
                <td>
                  <input type="number" class="appui-input appui-input--points" v-model.number="r.points" min="0" @change="savePoints(r)">
                </td>
                <td><button class="appui-switch" :class="{ 'is-on': r.status }" @click="toggleRule(r)"><span class="knob"></span></button></td>
                <td style="text-align:right">
                  <button class="appui-icon-btn appui-icon-btn--danger" title="Remover ação" @click="remove(r)"><i class="mdi mdi-trash-can-outline"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </section>

        <!-- Ranking -->
        <section class="appui-card appui-card--flush">
          <div class="appui-card-toolbar">
            <div class="appui-card-toolbar-left"><span class="appui-sec-title">Ranking</span></div>
            <div class="appui-card-toolbar-right">
              <button class="appui-btn appui-btn--ghost appui-btn--sm" title="Exportar Excel" @click="exportRanking()"><i class="mdi mdi-download mr-1"></i> Exportar</button>
              <button class="appui-btn appui-btn--ghost appui-btn--sm" style="color:#f46a6a" @click="reset()"><i class="mdi mdi-restart mr-1"></i> Zerar</button>
            </div>
          </div>

          <div v-if="!ranking.length" class="appui-inline-empty">Sem pontuação ainda — o ranking aparece conforme os participantes interagem.</div>
          <template v-else>
            <!-- Pódio top 3 -->
            <div class="appui-podium">
              <div v-for="(p, i) in podium" :key="p.id" class="appui-podium-slot" :class="'is-' + (i + 1)">
                <div class="appui-podium-medal">{{ ['🥇', '🥈', '🥉'][i] }}</div>
                <div class="appui-podium-avatar">{{ initials(p.name) }}</div>
                <div class="appui-podium-name" :title="p.name">{{ p.name }}</div>
                <div class="appui-podium-points">{{ p.total }} pts</div>
              </div>
            </div>
            <!-- Demais posições -->
            <table v-if="rest.length" class="appui-table">
              <tbody>
                <tr v-for="(r, i) in rest" :key="r.id">
                  <td style="width:50px;color:#adb5bd;font-weight:600">{{ i + 4 }}º</td>
                  <td style="font-weight:500;color:#495057">{{ r.name }}</td>
                  <td style="text-align:right;font-weight:700;color:#556ee6;width:90px">{{ r.total }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </section>
      </div>
    </div>

    <b-modal v-model="showModal" title="Nova ação de pontuação" hide-footer>
      <form @submit.prevent="save()">
        <div class="form-group"><label>Chave (sem espaços) *</label><input type="text" class="form-control" v-model="form.action" required placeholder="ex: view_map"></div>
        <div class="form-group"><label>Descrição *</label><input type="text" class="form-control" v-model="form.description" required placeholder="ex: Visualizar o mapa do evento"></div>
        <div class="form-group"><label>Pontos</label><input type="number" class="form-control" v-model.number="form.points" min="0"></div>
        <div class="text-right"><button type="button" class="btn btn-light mr-2" @click="showModal = false">Cancelar</button><button type="submit" class="btn btn-primary">Salvar</button></div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import { errorMessage, successMessage } from '@/components/alertsMessages'
import services from './services'
import './app-ui.css'

export default {
  components: {},
  name: 'app-gamification',
  data () {
    return {
      rules: [],
      ranking: [],
      enabled: false,
      showModal: false,
      form: { action: '', description: '', points: 0 }
    }
  },
  computed: {
    podium () { return this.ranking.slice(0, 3) },
    rest () { return this.ranking.slice(3) }
  },
  mounted () { this.load(); this.loadRanking() },
  methods: {
    initials (name) { return (name || '?').trim().split(/\s+/).slice(0, 2).map(w => w.charAt(0).toUpperCase()).join('') },
    load () {
      services.listGamification().then(r => { this.rules = r.data.data; this.enabled = r.data.enabled }).catch(() => errorMessage('Falha ao carregar.', 3000))
    },
    loadRanking () { services.gamRanking().then(r => { this.ranking = r.data.data }).catch(() => {}) },
    async toggleGlobal () {
      this.enabled = !this.enabled
      try {
        await services.toggleGamGlobal(this.enabled)
        successMessage('Gamificação atualizada.', 1500)
      } catch (e) {
        this.enabled = !this.enabled
        errorMessage('Falha ao atualizar.', 3000)
      }
    },
    async savePoints (r) { try { await services.updateGamRule(r.id, { points: r.points }) } catch (e) { errorMessage('Falha ao salvar pontos.', 3000) } },
    async toggleRule (r) { try { await services.gamRuleStatus(r.id); r.status = r.status ? 0 : 1 } catch (e) { errorMessage('Falha.', 3000) } },
    openCreate () { this.form = { action: '', description: '', points: 0 }; this.showModal = true },
    async save () {
      try {
        await services.createGamRule(this.form)
        this.showModal = false
        successMessage('Ação criada.', 2000)
        this.load()
      } catch (e) { errorMessage(e?.response?.data?.message || 'Falha ao criar.', 3000) }
    },
    async remove (r) {
      const ok = await this.$bvModal.msgBoxConfirm(`Remover "${r.description}"?`, { okTitle: 'Remover', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.deleteGamRule(r.id); this.load() } catch (e) { errorMessage('Falha ao remover.', 3000) }
    },
    async reset () {
      const ok = await this.$bvModal.msgBoxConfirm('Zerar TODO o ranking? Essa ação não afeta a carteira de pontos.', { title: 'Você tem certeza?', okTitle: 'Sim, zerar', cancelTitle: 'Cancelar', okVariant: 'danger' })
      if (!ok) return
      try { await services.resetGamRanking(); this.loadRanking(); successMessage('Ranking zerado.', 2000) } catch (e) { errorMessage('Falha.', 3000) }
    },
    async exportRanking () {
      const loader = this.$loading.show()
      try {
        const res = await services.exportGamification()
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        link.download = 'ranking-gamificacao.xlsx'
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (e) { errorMessage('Falha ao exportar.', 3000) } finally { loader.hide() }
    }
  }
}
</script>
